module.exports = __webpack_public_path__ + "static/media/3_.ba86be7f.png";